import { render, staticRenderFns } from "./TaskCardExpandedContent.vue?vue&type=template&id=11a68875&scoped=true&"
import script from "./TaskCardExpandedContent.vue?vue&type=script&lang=ts&"
export * from "./TaskCardExpandedContent.vue?vue&type=script&lang=ts&"
import style0 from "./TaskCardExpandedContent.vue?vue&type=style&index=0&id=11a68875&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a68875",
  null
  
)

export default component.exports